const regexGlobal = 'g';
const escapeRegex = /[.*+?^${}()|[\]\\]/g;
const escapeReplacer = '\\$&';
function escapeRegExp(string) {
    return string.replace(escapeRegex, escapeReplacer);
}
export function replaceAll(str, find, replace) {
    return str.replace(new RegExp(escapeRegExp(find), regexGlobal), replace);
}
//# sourceMappingURL=patterns.js.map